// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2B1Cb","logo":"Header_logo__2oJZT","auth":"Header_auth__3gyrX","login":"Header_login__2_QDm"};